var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLongLongClothing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 56,
    viewBox: "0 0 40 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22L5 23.5L10.5 11L11.5 25.5H28.5L29 10.5L35 23.5L39.5 22L32.4575 2.63303C31.8826 1.05227 30.3803 0 28.6983 0H24C24 1.33333 23.2 4.1 20 4.5C16.8 4.9 15.6667 1.66667 15.5 0H10.8017C9.11968 0 7.61736 1.05227 7.04254 2.63302L0 22Z",
    fill: "#213D58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 26H11.5L6 56H14.5L20 32L25.5 56H34.5L28.5 26Z",
    fill: "#213D58"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongLongClothing);
export default __webpack_public_path__ + "static/media/long-long-clothing.00e5bcc4.svg";
export { ForwardRef as ReactComponent };